module.exports = __webpack_public_path__ + "static/media/gatsibo_model_village2.8f0f85e0.jpg";